import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

type ContainerProps = {
  background: string;
  checked: boolean;
  disabled?: boolean;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 1.6rem;
  width: 1.6rem;
  padding: 0.2rem;

  background-color: ${({ background }) => background};
  border-radius: ${({ theme }) => theme.borderRadius.base};

  ${({ checked }) =>
    !checked &&
    css`
      border: 0.1rem solid ${pickColor('borderColorDarkSecondary')};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      border: 0.1rem solid ${pickColor('tabBorder')};
    `};
`;

export { Container };
